export function maskPan(pan?: string | null): string {
  if (!pan) return "—";
  const trimmed = pan.trim();
  if (trimmed.length <= 3) return trimmed;
  return `${trimmed.slice(0, 2)}••••${trimmed.slice(-1)}`;
}

export function maskAccountNumber(account?: string | null): string {
  if (!account) return "—";
  const trimmed = String(account).trim();
  if (trimmed.length <= 5) return trimmed;
  return `${trimmed.slice(0, 2)}••••${trimmed.slice(-3)}`;
}
